import PropTypes from 'prop-types';
import Icon from '@/components/ui/AppIcon';

export default function GoalsAchievementsCard({ goals, achievements }) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border hover-lift">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-crimson font-semibold text-foreground">Goals & Achievements</h3>
        <Icon name="TrophyIcon" size={24} className="text-accent" />
      </div>
      <div className="space-y-4">
        <div>
          <h4 className="text-sm font-inter font-medium text-foreground mb-3">Current Goals</h4>
          <div className="space-y-2">
            {goals?.map((goal) => (
              <div key={goal?.id} className="flex items-center justify-between p-2 bg-surface rounded-lg">
                <span className="text-sm font-inter text-foreground">{goal?.title}</span>
                <div className="flex items-center space-x-2">
                  <div className="w-16 bg-muted rounded-full h-1.5">
                    <div 
                      className="bg-primary h-1.5 rounded-full"
                      style={{ width: `${goal?.progress}%` }}
                    ></div>
                  </div>
                  <span className="text-xs font-inter text-muted-foreground">{goal?.progress}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div>
          <h4 className="text-sm font-inter font-medium text-foreground mb-3">Recent Achievements</h4>
          <div className="space-y-2">
            {achievements?.map((achievement) => (
              <div key={achievement?.id} className="flex items-center space-x-3 p-2 bg-success/5 rounded-lg">
                <div className="flex-shrink-0 w-8 h-8 bg-success/20 rounded-full flex items-center justify-center">
                  <Icon name="StarIcon" size={16} className="text-success" />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-inter font-medium text-foreground">{achievement?.title}</p>
                  <p className="text-xs font-inter text-muted-foreground">{achievement?.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

GoalsAchievementsCard.propTypes = {
  goals: PropTypes?.arrayOf(
    PropTypes?.shape({
      id: PropTypes?.number?.isRequired,
      title: PropTypes?.string?.isRequired,
      progress: PropTypes?.number?.isRequired
    })
  )?.isRequired,
  achievements: PropTypes?.arrayOf(
    PropTypes?.shape({
      id: PropTypes?.number?.isRequired,
      title: PropTypes?.string?.isRequired,
      date: PropTypes?.string?.isRequired
    })
  )?.isRequired
};